declare var window: any;

export default () => (
  !window.Promise ||
  typeof Object.assign !== 'function' ||
  !('classList' in document.createElement('a'))
);
